// File: NGOCompliance.jsx
import React from "react";

export default function NGOCompliance() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            NGO Compliance
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks ensures NGOs meet statutory, tax, and regulatory requirements.
          </p>
          <p className="text-gray-700">
            Complete compliance services including FCRA filings, 12A/80G renewals, annual returns, audit coordination, foreign funding compliance, and statutory registrations maintenance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: NGO/non-profit compliance - community organization work) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="NGO compliance services - non-profit regulatory support"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless NGO compliance filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Registration certificates (12A/80G/35AC)</li>
                <li>Audited accounts and financial statements</li>
                <li>Activity reports and project documentation</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Non-profit compliance specialists with proven expertise in FCRA, Income Tax, and statutory NGO regulations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  FCRA & Foreign Funding Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete FCRA compliance including Form FC-3C/FC-4 filings, foreign contribution utilization certificates, renewal applications, separate bank account maintenance, and MHA compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Tax Exemption Management
                </h3>
                <p className="text-gray-700 text-sm">
                  12A/80G/35AC renewal coordination, IT return filings (ITR-7), Form 10B audits, tax exemption certificates, donor deduction proofs, and Income Tax assessments handling.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Comprehensive Statutory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service compliance from annual returns (Form FC-3/FC-4), auditor coordination, board resolutions, statutory register maintenance, NGO Darpan registration, and ongoing regulatory advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
